export const UPDATE_DATE_PICKER_VALUE = 'UPDATE_DATE_PICKER_VALUE';

export const updateDatePickerValue = (field, value) => ({
  type: UPDATE_DATE_PICKER_VALUE,
  field,
  value,
});
